import React from 'react';

import { View } from 'react-native';
import { StyleSheet } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { WEB_MAX_WIDTH_STYLE, modalStyles } from 'components/card-modal';
import { CardModalHeader, ModalHeaderProps } from 'components/card-modal-header';
import { spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

interface IDrawerPage {
  children: React.ReactNode;
  headerText?: string | null | undefined;
  helmetTitle?: string;
  footer?: React.ReactNode;
  _headerOverride?: React.ReactNode;
  disableWebMaxWidth?: boolean;
}

export const DrawerPage: React.FC<React.PropsWithChildren<IDrawerPage & ModalHeaderProps>> = ({
  children,
  headerText,
  helmetTitle,
  dismissType,
  footer,
  _headerOverride,
  disableWebMaxWidth = false,
}) => {
  const { top, bottom } = useSafeAreaInsets();

  const finalFooter = footer && (
    <View style={[modalStyles.footerWrap, { paddingBottom: bottom || spacing.$4 }]}>
      <View style={[modalStyles.footerInner, WEB_MAX_WIDTH_STYLE]}>{footer}</View>
    </View>
  );

  return (
    <View style={{ flex: 1, paddingTop: top - 16 }}>
      {_headerOverride || (
        <CardModalHeader
          {...{
            headerText,
            helmetTitle,
            dismissType: dismissType || 'back',
            containerStyle: { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
          }}
        />
      )}
      <KeyboardAwareScrollView
        contentContainerStyle={modalStyles.scrollContainer}
        style={[modalStyles.scrollStyle, styles.scrollStyle]}
      >
        <View
          style={[
            modalStyles.wrappedChildren,
            styles.wrappedChildren,
            bottom ? { paddingBottom: bottom } : {},
            disableWebMaxWidth ? null : WEB_MAX_WIDTH_STYLE,
          ]}
        >
          {children}
        </View>
      </KeyboardAwareScrollView>
      {finalFooter}
    </View>
  );
};

const styles = StyleSheet.create({
  wrappedChildren: {
    paddingHorizontal: spacing.$4,
    height: isWeb ? '100%' : undefined,
  },
  scrollStyle: isWeb
    ? {
        alignSelf: 'center',
      }
    : {},
});

export default DrawerPage;
